
// src/context/UserProvider.js
import React, { createContext, useRef, useState, useEffect } from "react";

// Criação do contexto
export const MyContext = createContext();

// O UserProvider será o componente responsável por fornecer o estado
export const UserProvider = ({ children }) => {
  // Estados compartilhados
  const [produtos, setProdutos] = useState([]);
  const [produto1, setProduto1] = useState(null);
  const [produtoSearch, setProdutoSearch] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [produtosByCategoria, setProdutosByCategoria] = useState([]);
  const [mostrarCarrinho, setMostrarCarrinho] = useState(false);
  const [showOrcamento, setShowOrcamento] = useState(false);
  const [showTelaLogin, setShowTelaLogin] = useState(false);
  const [animateExitOrcamento, setAnimateExitOrcamento] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [scale, setScale] = useState(1);
  const [voltarAoMinimo, setVoltarAoMinimo] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [showAnimatedInput, setShowAnimatedInput] = useState(false);
  const [login, setLogin] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [dataUser, setDataUser] = useState([]);
  const [showTecidos, setShowTecidos] = useState(false);
  const [tecidoId, setTecidoId] = useState(90);
  const [showCadastroInProduto, setShowCadastroInProduto] = useState(false);
  const [showTecidoInOrcamento, setShowTecidoInOrcamento] = useState(false);
  const [newTecidoID, setNewTecidoId] = useState("");
  const [orcamentoId, setOrcamentoId] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [showLayoutMeusDados, setShowLayoutMeusDados] = useState(true);
  const [showLayoutEndereco, setShowLayoutEndereco] = useState(false);
  const [showLayoutNewEndereco, setShowLayoutNewEndereco] = useState(false);
  const [showLayoutEditEndereco, setShowLayoutEditEndereco] = useState(false);
  const [showLayoutAlterarSenha, setShowLayoutAlterarSenha] = useState(false);
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [opcaoDeParcela, setOpcaoDeParcela] = useState(1);
  const [formularioConcluido, setFormularioConcluido] = useState(false);
  const [showCheckoutPayment, setShowCheckoutPayment] = useState(false);
  const [orcamentosSelecionados, setOrcamentosSelecionados] = useState([]);
  const [showPedidos, setShowPedidos] = useState(false);
  const [showSideBarUser, setShowSideBarUser] = useState(true);
  // --- Adicionado: estado para acompanhar tamanho da janela ---
  const [windowSize, setWindowSize] = useState(() => {
    if (typeof window !== "undefined") {
      return { width: window.innerWidth, height: window.innerHeight };
    }
    return { width: 0, height: 0 };
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /**
   * ---------------------------
   * INTERCEPT BACK-BUTTON LOGIC (versão com PILHA)
   * ---------------------------
   */

  // Pilha de interceptações — guarda a ordem das chaves que ficaram true
  const interceptedStackRef = useRef([]);

  // Mapeamento nome -> setter
  const settersMapRef = useRef({
    mostrarCarrinho: setMostrarCarrinho,
    showOrcamento: setShowOrcamento,
    showTelaLogin: setShowTelaLogin,
    animateExitOrcamento: setAnimateExitOrcamento,
    voltarAoMinimo: setVoltarAoMinimo,
    showAnimatedInput: setShowAnimatedInput,
    login: setLogin,
    showUser: setShowUser,
    showTecidos: setShowTecidos,
    showCadastroInProduto: setShowCadastroInProduto,
    showTecidoInOrcamento: setShowTecidoInOrcamento,
    showLayoutMeusDados: setShowLayoutMeusDados,
    showLayoutEndereco: setShowLayoutEndereco,
    showLayoutNewEndereco: setShowLayoutNewEndereco,
    showLayoutEditEndereco: setShowLayoutEditEndereco,
    showLayoutAlterarSenha: setShowLayoutAlterarSenha,
    showConfirmationDelete: setShowConfirmationDelete,
    showSearchResults: setShowSearchResults,
    showCategories: setShowCategories,
    opcaoDeParcela: setOpcaoDeParcela,
    formularioConcluido: setFormularioConcluido,
    showCheckoutPayment: setShowCheckoutPayment,
    showPedidos: setShowPedidos,
    showSideBarUser: setShowSideBarUser,
  });

  // Lista dos estados booleanos monitorados
  const watchedBooleans = {
    mostrarCarrinho,
    showOrcamento,
    showTelaLogin,
    animateExitOrcamento,
    voltarAoMinimo,
    showAnimatedInput,
    login,
    showUser,
    showTecidos,
    showCadastroInProduto,
    showTecidoInOrcamento,
    showLayoutMeusDados,
    showLayoutEndereco,
    showLayoutNewEndereco,
    showLayoutEditEndereco,
    showLayoutAlterarSenha,
    showConfirmationDelete,
    showSearchResults,
    showCheckoutPayment,
    showCategories,
    opcaoDeParcela,
    formularioConcluido,
    showPedidos,
    showSideBarUser,

  };

  // Adiciona entrada no histórico para cada novo estado true
  useEffect(() => {
    if (typeof window === "undefined") return;

    const activeKeys = Object.keys(watchedBooleans).filter(
      (k) => watchedBooleans[k] === true
    );

    if (activeKeys.length === 0) return;

    const stack = interceptedStackRef.current;

    activeKeys.forEach((key) => {
      if (!stack.includes(key)) {
        stack.push(key);
        try {
          window.history.pushState({ intercepted: true, key }, "");

        } catch (err) {
          console.warn("pushState falhou:", err);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    mostrarCarrinho,
    showOrcamento,
    showTelaLogin,
    animateExitOrcamento,
    voltarAoMinimo,
    showAnimatedInput,
    login,
    showUser,
    showTecidos,
    showCadastroInProduto,
    showTecidoInOrcamento,
    showLayoutMeusDados,
    showLayoutEndereco,
    showLayoutNewEndereco,
    showLayoutEditEndereco,
    showLayoutAlterarSenha,
    showConfirmationDelete,
    showSearchResults,
    showCheckoutPayment,
    showCategories,
    opcaoDeParcela,
    formularioConcluido,
    showPedidos,
    showSideBarUser,
  ]);

  // Remove interceptação quando popstate dispara
  useEffect(() => {
    if (typeof window === "undefined") return;

    const onPopState = () => {
      const stack = interceptedStackRef.current;

      if (stack.length > 0) {
        const lastKey = stack.pop();
        const setter = settersMapRef.current[lastKey];

        if (typeof setter === "function") {
          try {
            setter(false);
          } catch (err) {
            console.warn("Erro ao setar", lastKey, "=> false", err);
          }
        }

        try {
          window.history.replaceState(null, "");
        } catch {
          /* ignore */
        }


      }
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  // Sincroniza pilha ao fechar modais programaticamente
  useEffect(() => {
    const stack = interceptedStackRef.current;
    const activeKeys = Object.keys(watchedBooleans).filter(
      (k) => watchedBooleans[k] === true
    );
    interceptedStackRef.current = stack.filter((k) =>
      activeKeys.includes(k)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    mostrarCarrinho,
    showOrcamento,
    showTelaLogin,
    animateExitOrcamento,
    voltarAoMinimo,
    showAnimatedInput,
    login,
    showUser,
    showTecidos,
    showCadastroInProduto,
    showTecidoInOrcamento,
    showLayoutMeusDados,
    showLayoutEndereco,
    showLayoutNewEndereco,
    showLayoutEditEndereco,
    showLayoutAlterarSenha,
    showConfirmationDelete,
    showSearchResults,
    showCheckoutPayment,
    showCategories,
    opcaoDeParcela,
    formularioConcluido,
    showPedidos,
    showSideBarUser,
  ]);

  return (
    <MyContext.Provider
      value={{
        usuario,
        setUsuario,
        orcamentoId,
        setOrcamentoId,
        newTecidoID,
        setNewTecidoId,
        showTecidoInOrcamento,
        setShowTecidoInOrcamento,
        produtos,
        setProdutos,
        produto1,
        setProduto1,
        produtoSearch,
        setProdutoSearch,
        categorias,
        setCategorias,
        produtosByCategoria,
        setProdutosByCategoria,
        mostrarCarrinho,
        setMostrarCarrinho,
        showOrcamento,
        setShowOrcamento,
        showTelaLogin,
        setShowTelaLogin,
        animateExitOrcamento,
        setAnimateExitOrcamento,
        scrollY,
        setScrollY,
        scale,
        setScale,
        voltarAoMinimo,
        setVoltarAoMinimo,
        timeElapsed,
        setTimeElapsed,
        showAnimatedInput,
        setShowAnimatedInput,
        login,
        setLogin,
        showUser,
        setShowUser,
        showTecidos,
        setShowTecidos,
        tecidoId,
        setTecidoId,
        showCadastroInProduto,
        setShowCadastroInProduto,
        windowSize,
        setWindowSize,
        dataUser,
        setDataUser,
        showLayoutMeusDados,
        setShowLayoutMeusDados,
        showLayoutEndereco,
        setShowLayoutEndereco,
        showLayoutNewEndereco,
        setShowLayoutNewEndereco,
        showLayoutEditEndereco,
        setShowLayoutEditEndereco,
        showLayoutAlterarSenha,
        setShowLayoutAlterarSenha,
        showConfirmationDelete,
        setShowConfirmationDelete,
        setShowSearchResults,
        showSearchResults,
        setShowCategories,
        showCategories,
        setOpcaoDeParcela,
        opcaoDeParcela,
        setFormularioConcluido,
        formularioConcluido,
        setShowCheckoutPayment,
        showCheckoutPayment,
        orcamentosSelecionados,
        setOrcamentosSelecionados,
        setShowPedidos,
        showPedidos,
        setShowSideBarUser,
        showSideBarUser
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
